import { Navigate, useLocation } from "react-router-dom";

export default function Success() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("context", "linked");

  return (
    <Navigate
      replace
      to={{
        pathname: "/auth",
        search: `?${params.toString()}`,
        hash: location.hash,
      }}
    />
  );
}
